import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "col-lg-6 d-flex flex-column justify-content-end" }
const _hoisted_6 = { class: "row mt-5" }
const _hoisted_7 = { class: "col-lg-6 col-md-12" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "float-right" }
const _hoisted_11 = { class: "dropdown d-inline mr-2" }
const _hoisted_12 = {
  class: "dropdown-menu dropdown-menu-right",
  role: "menu"
}
const _hoisted_13 = { class: "col-lg-6 col-md-12" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-header" }
const _hoisted_16 = { class: "float-right" }
const _hoisted_17 = { class: "dropdown d-inline mr-2" }
const _hoisted_18 = {
  class: "dropdown-menu dropdown-menu-right",
  role: "menu"
}
const _hoisted_19 = { class: "table-responsive" }
const _hoisted_20 = { class: "table table-hover" }
const _hoisted_21 = {
  class: "text-center align-middle",
  style: {"min-width":"200px","width":"200px","max-width":"200px"}
}
const _hoisted_22 = {
  class: "text-right align-middle",
  style: {"min-width":"250px","width":"auto"}
}
const _hoisted_23 = { style: {"min-width":"300px","width":"300px","max-width":"300px"} }
const _hoisted_24 = { class: "text-primary" }
const _hoisted_25 = {
  class: "text-center align-middle",
  style: {"min-width":"100px","width":"100px","max-width":"100px"}
}
const _hoisted_26 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_27 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_28 = {
  class: "text-center align-middle",
  style: {"min-width":"250px","width":"250px","max-width":"250px"}
}
const _hoisted_29 = { class: "text-primary" }
const _hoisted_30 = {
  class: "text-center align-middle",
  style: {"min-width":"200px","width":"200px","max-width":"200px"}
}
const _hoisted_31 = {
  class: "text-right align-middle",
  style: {"min-width":"250px","width":"auto"}
}
const _hoisted_32 = {
  class: "progress justify-content-end",
  style: {"height":"30px"}
}
const _hoisted_33 = {
  class: "align-middle",
  style: {"min-width":"250px","width":"auto"}
}
const _hoisted_34 = {
  class: "progress",
  style: {"height":"30px"}
}

import { computed, onMounted, watch, nextTick, shallowReactive, ref, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import { getDistinctColor, numCompare, toPercentageString, toStringSmartly } from '@common/Common'
    import CorporateNavigation from "@common/Components/CorporateNavigation.vue"
    import ScenarioNavigation from '@Quest/CorporateScenarios/Components/ScenarioNavigation.vue'

    import { KendoChart, KendoChartDataSerie, KendoChartOptions } from '@Kendo/Components/KendoChart'

    import { useProjectsPageQueryV1 } from '@Quest/CorporateScenarios/queries-vue-composables'

    import type {
        PortfolioReadModel,
        ProjectsPageReadModel,
        SelectionProjectReadModel
    } from '@Quest/CorporateScenarios/readmodels'


    // ======================
    // Route
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectsPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))
    const scenarioId = computed(() => String(route.params.scenarioId ?? ''))


    // ======================
    // Query
    // ======================

    const {
        runProjectsPageQueryV1,
        modelProjectsPageQueryV1
    } = useProjectsPageQueryV1(workspaceId, strategyId, scenarioId)

    const rm = modelProjectsPageQueryV1 as Ref<ProjectsPageReadModel | null>


    // ======================
    // Local state
    // ======================

    const searchPhrase = ref<string | null>(null)

    // ======================================================
    // Charts (unchanged logic)
    // ======================================================

    class EfficientFrontierChart
    {
        isRendered: boolean = false
        Chart: KendoChart

        constructor()
        {
            const options = new KendoChartOptions()
            options.HideLegend()
            options.SetPannable(true)
            options.SetZoomable(true)
            options.SetTooltip(false, '#= dataItem.Name #')

            this.Chart = KendoChart.CreateScatterChart(options)
        }

        SetData(
            projects: SelectionProjectReadModel[],
            currencyLabel: string,
            portfolios: PortfolioReadModel[]
        )
        {
            let dataItems: {
                Id: string,
                Name: string,
                PortfolioId: string,
                PortfolioName: string,
                X: number,
                Y: number,
                Z: number,
                TooltipHtml: string
            }[] = []

            for (const p of projects)
            {
                dataItems.push({
                    Id: p.Id,
                    Name: p.Name,
                    X: p.TotalCost as number,
                    Y: p.TotalValue as number,
                    Z: p.CostOfValuePoint as number,
                    PortfolioId: p.PortfolioId,
                    PortfolioName: p.PortfolioName,
                    TooltipHtml: `${p.Name}`
                })
            }

            dataItems = dataItems
                .filter(a => a.X != null && a.Y != null && a.Z != null)
                .sort((a, b) => numCompare(a.Z, b.Z))

            for (let i = 1; i < dataItems.length; i++)
            {
                dataItems[i].X += dataItems[i - 1].X
                dataItems[i].Y += dataItems[i - 1].Y
            }

            const series: KendoChartDataSerie[] = portfolios.map(portfolio =>
            {
                const serie = new KendoChartDataSerie()
                serie.SetXField("X")
                serie.SetYField("Y")
                serie.SetCategoryField("Name")
                serie.SetColor(portfolio.Color)
                serie.SetMarkers(true, "circle")
                serie.SetData(dataItems.filter(a => a.PortfolioId === portfolio.Id))
                return serie
            })

            const options = this.Chart.GetOptions()
            options.SetTooltip(true, "#= dataItem.TooltipHtml #")

            const xMaxValue = Math.max(...dataItems.map(v => v.X))
            const yMaxValue = Math.max(...dataItems.map(v => v.Y))

            options.SetXAxis(
                null,
                0,
                xMaxValue * 1.1,
                `Cost (${currencyLabel})`,
                xMaxValue > 10 ? "{0:n0}" : null,
                2,
                true,
                true,
                null,
                xMaxValue
                    ? (e: any): string => kendo.toString(e.value / xMaxValue, "p0")
                    : undefined
            )

            options.SetYAxis(
                null,
                0,
                yMaxValue * 1.1,
                "Value",
                yMaxValue > 10 ? "{0:n0}" : null,
                true,
                true,
                null,
                yMaxValue
                    ? (e: any): string => kendo.toString(e.value / yMaxValue, "p0")
                    : undefined
            )

            this.Chart.SetOptions(options)
            this.Chart.SetDataSeries(series)
            this.Chart.UpdateOptions()
        }

        Render()
        {
            if (!this.isRendered)
            {
                this.Chart.Render1("EfficientFrontier")
                this.isRendered = true
            }
        }
    }


    class PrioritizationMatrixChart
    {
        isRendered: boolean = false
        Chart: KendoChart

        constructor()
        {
            const options = new KendoChartOptions()
            options.HideLegend()
            options.SetPannable(true)
            options.SetZoomable(true)
            options.SetTooltip(false, '#= dataItem.Name #')

            this.Chart = KendoChart.CreateScatterChart(options)
        }

        SetData(
            projects: SelectionProjectReadModel[],
            currencyLabel: string,
            portfolios: PortfolioReadModel[]
        )
        {
            let dataItems: {
                Id: string,
                Name: string,
                PortfolioId: string,
                PortfolioName: string,
                X: number,
                Y: number,
                TooltipHtml: string
            }[] = []

            for (const p of projects)
            {
                dataItems.push({
                    Id: p.Id,
                    Name: p.Name,
                    X: p.TotalCost as number,
                    Y: p.TotalValue as number,
                    PortfolioId: p.PortfolioId,
                    PortfolioName: p.PortfolioName,
                    TooltipHtml: `${p.Name}`
                })
            }

            dataItems = dataItems.filter(a => a.X != null && a.Y != null)

            const series: KendoChartDataSerie[] = portfolios.map(portfolio =>
            {
                const serie = new KendoChartDataSerie()
                serie.SetXField("X")
                serie.SetYField("Y")
                serie.SetCategoryField("Name")
                serie.SetColor(portfolio.Color)
                serie.SetMarkers(true, "circle")
                serie.SetData(dataItems.filter(a => a.PortfolioId === portfolio.Id))
                return serie
            })

            const options = this.Chart.GetOptions()
            options.SetTooltip(true, "#= dataItem.TooltipHtml #")

            const xMaxValue = Math.max(...dataItems.map(v => v.X))
            const yMaxValue = Math.max(...dataItems.map(v => v.Y))

            options.SetXAxis(
                null,
                0,
                xMaxValue * 1.1,
                `Cost (${currencyLabel})`,
                xMaxValue > 10 ? "{0:n0}" : null,
                2,
                true,
                false,
                null
            )

            options.SetYAxis(
                null,
                0,
                yMaxValue * 1.1,
                "Value",
                yMaxValue > 10 ? "{0:n0}" : null,
                true,
                false,
                null
            )

            this.Chart.SetOptions(options)
            this.Chart.SetDataSeries(series)
            this.Chart.UpdateOptions()
        }

        Render()
        {
            if (!this.isRendered)
            {
                this.Chart.Render1("PrioritizationMatrix")
                this.isRendered = true
            }
        }
    }


    const EfficientFrontier = shallowReactive(new EfficientFrontierChart())
    const PrioritizationMatrix = shallowReactive(new PrioritizationMatrixChart())


    // ======================
    // Computed
    // ======================

    const projectsView = computed<SelectionProjectReadModel[]>(() =>
    {
        let view = new Array(...(rm.value?.Projects ?? []))

        if (searchPhrase.value)
        {
            const phrase = searchPhrase.value.toLowerCase()
            view = view.filter(a => a.Name.toLowerCase().indexOf(phrase) > -1)
        }

        return view
    })


    // ======================
    // Formatters
    // ======================

    function fmtNum(val: number | null)
    {
        return toStringSmartly(val)
    }

    function fmtPct(val: number | null)
    {
        return toPercentageString(val)
    }


    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = "Enterprise Plan - Projects"
        runProjectsPageQueryV1()
    })


    // ======================
    // Replace onSetModel
    // ======================

    watch(rm, (current) =>
    {
        if (!current) return

        current.Portfolios.forEach((p, index) => p.Color = getDistinctColor(index))

        EfficientFrontier.SetData(current.Projects, current.CurrencyLabel, current.Portfolios)
        PrioritizationMatrix.SetData(current.Projects, current.CurrencyLabel, current.Portfolios)

        nextTick(() =>
        {
            EfficientFrontier.Render()
            PrioritizationMatrix.Render()
        })
    })


    // ======================
    // Replace onScheduled (query only version)
    // ======================

    function onScheduled()
    {
        runProjectsPageQueryV1()
    }


return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation, { ActivePage: "dashboard" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("small", _hoisted_4, "Enterprise Plan: " + _toDisplayString(_unref(rm).ScenarioName), 1 /* TEXT */),
              _cache[0] || (_cache[0] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Projects", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(ScenarioNavigation, { onScheduled: onScheduled })
            ])
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[1] || (_cache[1] = _createElementVNode("button", {
                        "data-toggle": "dropdown",
                        class: "btn btn-secondary btn-sm"
                      }, "Legend", -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Portfolios, (p) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: p.Id,
                            class: "dropdown-item-text"
                          }, [
                            _createElementVNode("i", {
                              class: "fa-solid fa-circle",
                              style: _normalizeStyle({'color': p.Color})
                            }, null, 4 /* STYLE */),
                            _createTextVNode(" " + _toDisplayString(p.Name), 1 /* TEXT */)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("h5", null, "Efficient Frontier", -1 /* CACHED */))
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-body chart-container" }, [
                  _createElementVNode("div", {
                    id: "Chart-EfficientFrontier",
                    style: {"max-width":"100%","height":"100%","overflow":"auto"}
                  })
                ], -1 /* CACHED */))
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _cache[4] || (_cache[4] = _createElementVNode("button", {
                        "data-toggle": "dropdown",
                        class: "btn btn-secondary btn-sm"
                      }, "Legend", -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Portfolios, (p) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: p.Id,
                            class: "dropdown-item-text"
                          }, [
                            _createElementVNode("i", {
                              class: "fa-solid fa-circle",
                              style: _normalizeStyle({'color': p.Color})
                            }, null, 4 /* STYLE */),
                            _createTextVNode(" " + _toDisplayString(p.Name), 1 /* TEXT */)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("h5", null, "Prioritization Matrix", -1 /* CACHED */))
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-body chart-container" }, [
                  _createElementVNode("div", {
                    id: "Chart-PrioritizationMatrix",
                    style: {"max-width":"100%","height":"100%","overflow":"auto"}
                  })
                ], -1 /* CACHED */))
              ])
            ])
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("table", _hoisted_20, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _cache[11] || (_cache[11] = _createElementVNode("th", {
                      class: "align-middle",
                      style: {"min-width":"300px","width":"300px","max-width":"300px"}
                    }, "Project", -1 /* CACHED */)),
                    _cache[12] || (_cache[12] = _createElementVNode("th", {
                      class: "text-center align-middle",
                      style: {"min-width":"100px","width":"100px","max-width":"100px"}
                    }, "P&L", -1 /* CACHED */)),
                    _cache[13] || (_cache[13] = _createElementVNode("th", {
                      class: "text-center align-middle",
                      style: {"min-width":"250px","width":"250px","max-width":"250px"}
                    }, "Portfolio", -1 /* CACHED */)),
                    _createElementVNode("th", _hoisted_21, [
                      _cache[7] || (_cache[7] = _createTextVNode("Cost of value point ", -1 /* CACHED */)),
                      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createTextVNode(" (" + _toDisplayString(_unref(rm).CurrencyLabel) + ")", 1 /* TEXT */)
                    ]),
                    _createElementVNode("th", _hoisted_22, [
                      _cache[9] || (_cache[9] = _createTextVNode("Costs ", -1 /* CACHED */)),
                      _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createTextVNode(" (" + _toDisplayString(_unref(rm).CurrencyLabel) + ")", 1 /* TEXT */)
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("th", {
                      class: "align-middle",
                      style: {"min-width":"250px","width":"auto"}
                    }, [
                      _createTextVNode("Value "),
                      _createElementVNode("br"),
                      _createTextVNode(" (0-100)")
                    ], -1 /* CACHED */))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectsView.value, (a) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: a.Id
                    }, [
                      _createElementVNode("td", _hoisted_23, [
                        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_24, [
                          _createTextVNode(_toDisplayString(a.Name), 1 /* TEXT */)
                        ])), [
                          [_directive_sanitizedHref, `/#/portfolio/alternative/dashboard/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.Id}`]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_25, [
                        (a.HasActivePlan)
                          ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_26, [...(_cache[15] || (_cache[15] = [
                              _createTextVNode(" View ", -1 /* CACHED */)
                            ]))])), [
                              [_directive_sanitizedHref, `/#/q/project/pnl/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.Id}`]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_27, [...(_cache[16] || (_cache[16] = [
                              _createTextVNode(" Not available ", -1 /* CACHED */)
                            ]))])), [
                              [_directive_sanitizedHref, `/q/project/summary/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.Id}`]
                            ])
                      ]),
                      _createElementVNode("td", _hoisted_28, [
                        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_29, [
                          _createTextVNode(_toDisplayString(a.PortfolioName), 1 /* TEXT */)
                        ])), [
                          [_directive_sanitizedHref, `/#/portfolio-plan/selection/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.ScenarioId}`]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(fmtNum(a.CostOfValuePoint)), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", {
                            class: "progress-bar bg-danger",
                            role: "progressbar",
                            style: _normalizeStyle({width: a.NormalizedTotalCost + '%'})
                          }, _toDisplayString(fmtNum(a.TotalCost)), 5 /* TEXT, STYLE */)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", {
                            class: "progress-bar bg-success",
                            role: "progressbar",
                            style: _normalizeStyle({width: a.TotalValue + '%'})
                          }, _toDisplayString(fmtNum(a.TotalValue)), 5 /* TEXT, STYLE */)
                        ])
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})